import React, { useEffect, useRef, useState } from "react";
import "../EmployerUpdateProfile/EmployerUpdate.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import ProfileUpdate from "../EmployerUpdateProfile/ProfileUpdate";
import CompanyDetails from "./CompanyDetails";
import CompanyProof from "./CompanyProof";
import ContactPersonDetails from "./ContactPersonDetails";
import Context from "./EmpContext";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import WorkIcon from "@mui/icons-material/Work";
import {
  Drawer,
  Button,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import { useNavigate } from "react-router";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import FactoryIcon from "@mui/icons-material/Factory";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Divider from "@mui/material/Divider";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import List from "@mui/material/List";
import useAxios from "../../../api/useAxios";
import Slide from "@mui/material/Slide";
import ListItemText from "@mui/material/ListItemText";
const theme = createTheme();
const drawerWidth = 220;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const EmployerUpdate = () => {
  const navigate = useNavigate();
  const axiosData = useAxios();
  let userDetails = JSON.parse(localStorage.getItem("user"));
  if (userDetails === null || userDetails === undefined) {
    navigate(
      `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.PageNotFound}`
    );
  }
  const Location = useLocation();
  const [declined, setDeclined] = useState();
  let [empData, setempData] = useState({});
  const [put, setput] = useState(false);
  const [state, setState] = useState(false);
  const [quickactive, setQuickActive] = useState("quickactive");
  const [loading, setLoading] = useState(true);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 5),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-around",
  }));
  useEffect(() => {
    if (userDetails === null || userDetails === undefined) {
      navigate(
        `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.PageNotFound}`
      );
    } else {
      axiosData
        .get(`employers/email/${Location.state}/users`)
        .then((data) => {
          empData = data.data;
          if (empData.email_id === userDetails.emailId) {
            setempData({ ...empData });
            const userId = empData.user_id;
            const emailId = empData.email_id;
            const company_name = empData.company_name;
            const mobile_number = empData.mobile_number;
            const logoPic = empData.logoUpload;
            localStorage.setItem(
              "user",
              JSON.stringify({
                userId,
                emailId,
                company_name,
                mobile_number,
                logoPic,
              })
            );
            setLoading(false);
          } else {
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            setDeclined(true);
          }
        });
      setput(false);
    }
  }, [put]);

  const CompanyDetailsRoute = useRef(null);
  const GovermentProofRoute = useRef(null);
  const ContactDetailsRoute = useRef(null);

  if (loading === false) {
    return (
      <>
        <Context.Provider value={empData}>
          <div>
            <ThemeProvider theme={theme}>
              <Box className="full-content" sx={{ p: 2 }}>
                <Grid
                  sx={{
                    mb: 1,
                    pt: 1,
                    pl: 2,
                    mt: -1,
                    position: "sticky",
                    top: "0",
                    backgroundColor: "white",
                    borderRadius: 2,
                  }}
                  id="mobileView"
                  container
                  xs={12}
                  sm={12}
                >
                  <div id="mobileView">
                    <div
                      style={{
                        display: "flex",
                        width: "90%",
                      }}
                    >
                      <MenuIcon onClick={toggleDrawer(true)} />

                      <Typography sx={{ fontSize: "18px", pb: 1, ml: 1 }}>
                        <b>Quick Links</b>
                      </Typography>
                    </div>

                    <Drawer
                      className="QDrawer"
                      sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                          width: drawerWidth,
                          boxSizing: "border-box",
                          backgroundColor: "#339fcd",
                        },
                      }}
                      variant="persistent"
                      anchor="left"
                      open={state}
                      onClose={toggleDrawer(false)}
                    >
                      <DrawerHeader sx={{ backgroundColor: "white" }}>
                        <Typography sx={{ fontSize: "18px" }}>
                          <b>Quick Links</b>
                        </Typography>{" "}
                        <CloseIcon
                          sx={{ ml: 0.3 }}
                          onClick={toggleDrawer(false)}
                        />
                      </DrawerHeader>
                      <Divider />
                      <Grid container flexDirection="column">
                        <ListItem
                          sx={{ padding: "1px 0px" }}
                          onClick={() =>
                            CompanyDetailsRoute.current.scrollIntoView({
                              behavior: "smooth",
                            })
                          }
                        >
                          <a className="hover">
                            <ListItemButton
                              sx={{ borderRadius: "10px" }}
                              className="link-active"
                              onClick={toggleDrawer(false)}
                            >
                              <ListItemIcon>
                                <ApartmentIcon className="text" />
                              </ListItemIcon>
                              <ListItemText
                                className="text"
                                sx={{ color: "#fff" }}
                              >
                                <span className="font">Company Details</span>
                              </ListItemText>
                            </ListItemButton>
                          </a>
                        </ListItem>
                        <ListItem
                          sx={{ padding: "1px 0px" }}
                          onClick={() => {
                            GovermentProofRoute.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }}
                        >
                          <a className="hover">
                            <ListItemButton
                              sx={{ borderRadius: "10px" }}
                              className="link-active"
                              onClick={toggleDrawer(false)}
                            >
                              <ListItemIcon>
                                <AssuredWorkloadIcon className="text" />
                              </ListItemIcon>
                              <ListItemText
                                className="text"
                                sx={{ color: "#fff" }}
                              >
                                <span className="font"> Goverment Proof</span>
                              </ListItemText>
                            </ListItemButton>
                          </a>
                        </ListItem>
                        <ListItem
                          sx={{ padding: "1px 0px" }}
                          onClick={() =>
                            ContactDetailsRoute.current.scrollIntoView({
                              behavior: "smooth",
                            })
                          }
                        >
                          <a className="hover">
                            <ListItemButton
                              sx={{ borderRadius: "10px" }}
                              className="link-active"
                              onClick={toggleDrawer(false)}
                            >
                              <ListItemIcon>
                                <PermContactCalendarIcon className="text" />
                              </ListItemIcon>
                              <ListItemText
                                className="text"
                                sx={{ color: "#fff" }}
                              >
                                <span className="font"> Contact Details</span>
                              </ListItemText>
                            </ListItemButton>
                          </a>
                        </ListItem>

                        <ListItemButton onClick={handleClick}>
                          <ListItemIcon>
                            <WorkIcon className="text" sx={{ color: "#fff" }} />
                          </ListItemIcon>
                          <ListItemText
                            primary="Job Post"
                            className="text"
                            sx={{ color: "#fff" }}
                          />
                          {open ? (
                            <ExpandLess sx={{ color: "#fff" }} />
                          ) : (
                            <ExpandMore sx={{ color: "#fff" }} />
                          )}
                        </ListItemButton>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding>
                            <ListItemButton
                              sx={{ pl: 4, borderRadius: "10px" }}
                              onClick={() => {
                                navigate(
                                  ROUTINGDATA.LAND +
                                    ROUTINGDATA.MAIN +
                                    ROUTINGDATA.POSTJOB,
                                  {
                                    state: userDetails.userId,
                                  }
                                );
                                toggleDrawer(false);
                              }}
                            >
                              <ListItemIcon>
                                <PostAddIcon
                                  className="text"
                                  sx={{ color: "#fff" }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary="Post New Job"
                                sx={{ color: "#fff" }}
                              />
                            </ListItemButton>
                            <ListItemButton
                              sx={{ pl: 4, borderRadius: "10px" }}
                              onClick={() => {
                                navigate(
                                  ROUTINGDATA.LAND +
                                    ROUTINGDATA.MAIN +
                                    ROUTINGDATA.POSTEDJOB,
                                  {
                                    state: userDetails.userId,
                                  }
                                );
                                toggleDrawer(false);
                              }}
                            >
                              <ListItemIcon>
                                <ListAltIcon
                                  className="text"
                                  sx={{ color: "#fff" }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary="Posted Jobs"
                                sx={{ color: "#fff" }}
                              />
                            </ListItemButton>
                          </List>
                        </Collapse>
                        {/* <ListItem
                            sx={{ padding: "1px 0px" }}
                            onClick={() => {
                              navigate(
                                ROUTINGDATA.LAND +
                                  ROUTINGDATA.MAIN +
                                  ROUTINGDATA.APPLIEDSEEKERS,
                                {
                                  state: {
                                    userId: userDetails.userId,
                                    company_name: empData.company_name,
                                  },
                                }
                              );
                            }}
                          >
                            <a className="hover">
                              <ListItemButton
                                sx={{ borderRadius: "10px" }}
                                className="link-active"
                                onClick={toggleDrawer(false)}
                              >
                                <ListItemIcon>
                                  <HowToRegIcon className="text" />
                                </ListItemIcon>
                                <ListItemText
                                  className="text"
                                  sx={{ color: "#fff" }}
                                >
                                  <span className="font"> Applied Seekers</span>
                                </ListItemText>
                              </ListItemButton>
                            </a>
                          </ListItem> */}
                        <ListItem
                          sx={{ padding: "1px 0px" }}
                          onClick={() => {
                            navigate(
                              ROUTINGDATA.LAND +
                                ROUTINGDATA.MAIN +
                                ROUTINGDATA.SUBSCRIPTIONS,
                              {
                                state: {
                                  userId: userDetails.userId,
                                  company_name: empData.company_name,
                                },
                              }
                            );
                          }}
                        >
                          <a className="hover">
                            <ListItemButton
                              sx={{ borderRadius: "10px" }}
                              className="link-active"
                              onClick={toggleDrawer(false)}
                            >
                              <ListItemIcon>
                                <HowToRegIcon className="text" />
                              </ListItemIcon>
                              <ListItemText
                                className="text"
                                sx={{ color: "#fff" }}
                              >
                                <span className="font"> Buy Posting</span>
                              </ListItemText>
                            </ListItemButton>
                          </a>
                        </ListItem>
                      </Grid>
                    </Drawer>
                  </div>
                </Grid>
                <Grid className="Card" sx={{ p: 4 }} xs={12} md={12} lg={12}>
                  <Box className="Avator">
                    <ProfileUpdate setput={setput} number={empData._id} />
                    <Box>
                      <Typography
                        gutterBottom
                        sx={{
                          wordWrap: "break-word",
                          fontWeight: 600,
                        }}
                      >
                        <ApartmentIcon
                          sx={{ mb: -0.8, mr: 1, color: "#135c82" }}
                        />
                        {empData.company_name}
                      </Typography>
                      <Typography
                        gutterBottom
                        sx={{
                          wordWrap: "break-word",
                          fontWeight: 600,
                        }}
                      >
                        <FactoryIcon
                          sx={{ mb: -0.8, mr: 1, color: "#135c82" }}
                        />
                        {empData.industry}
                      </Typography>

                      <Typography
                        gutterBottom
                        sx={{
                          wordWrap: "break-word",
                          fontWeight: 600,
                        }}
                      >
                        <MailOutlineIcon
                          sx={{ mb: -0.8, mr: 1, color: "#135c82" }}
                        />
                        {empData.email_id}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid container>
                  <Grid
                    id="EmpQuickLinkhide"
                    sx={{
                      mt: 4,
                      mr: 2,
                      pt: 2,
                      pl: 2,
                      position: "sticky",
                      top: 0,
                    }}
                    className="Card"
                    container
                    xs={12}
                    sm={12}
                    md={1.8}
                    lg={1.8}
                  >
                    <div style={{ height: "300px" }}>
                      <Grid container flexDirection="column">
                        <Typography sx={{ fontSize: "18px", pb: 2 }}>
                          <b>Quick Links</b>
                        </Typography>
                        <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          <Typography
                            id={
                              quickactive === "quickactive"
                                ? "quickactive"
                                : "quickactive1"
                            }
                            sx={{ fontWeight: 600 }}
                            onClick={() => {
                              CompanyDetailsRoute.current.scrollIntoView({
                                behavior: "smooth",
                              });
                              setQuickActive("quickactive");
                            }}
                          >
                            Company Details
                          </Typography>
                        </Grid>
                        <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          {" "}
                          <Typography
                            sx={{ fontWeight: 600 }}
                            id={
                              quickactive === "quickactive2"
                                ? "quickactive"
                                : "quickactive1"
                            }
                            onClick={() => {
                              GovermentProofRoute.current.scrollIntoView({
                                behavior: "smooth",
                              });
                              setQuickActive("quickactive2");
                            }}
                          >
                            Goverment Proof
                          </Typography>
                        </Grid>
                        <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          <Typography
                            id={
                              quickactive === "quickactive3"
                                ? "quickactive"
                                : "quickactive1"
                            }
                            sx={{ fontWeight: 600 }}
                            onClick={() => {
                              ContactDetailsRoute.current.scrollIntoView({
                                behavior: "smooth",
                              });
                              setQuickActive("quickactive3");
                            }}
                          >
                            Contact Details
                          </Typography>
                        </Grid>

                        <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          <div
                            style={{ display: "flex", gap: "30px" }}
                            onClick={handleClick}
                          >
                            <Typography
                              sx={{ fontWeight: 600 }}
                              id="quickactive1"
                              onClick={handleClick}
                            >
                              Job Post{" "}
                            </Typography>
                            {open ? (
                              <ExpandLess onClick={handleClick} />
                            ) : (
                              <ExpandMore onClick={handleClick} />
                            )}
                          </div>
                          <Collapse in={open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              <ListItemButton
                                sx={{ fontWeight: 600, pl: 4 }}
                                id="quickactive1"
                                onClick={() => {
                                  if (
                                    empData.no_of_free_posting <= 0 &&
                                    empData.no_of_hot_posting <= 0 &&
                                    empData.no_of_Standard_posting <= 0
                                  ) {
                                    navigate(
                                      ROUTINGDATA.LAND +
                                        ROUTINGDATA.MAIN +
                                        ROUTINGDATA.SUBSCRIPTIONS,
                                      {
                                        state: userDetails.userId,
                                      }
                                    );
                                  } else {
                                    navigate(
                                      ROUTINGDATA.LAND +
                                        ROUTINGDATA.MAIN +
                                        ROUTINGDATA.POSTJOB,
                                      {
                                        state: userDetails.userId,
                                      }
                                    );
                                  }
                                }}
                              >
                                Post New Job
                              </ListItemButton>
                              <ListItemButton
                                sx={{ fontWeight: 600, pl: 4 }}
                                id="quickactive1"
                                onClick={() => {
                                  navigate(
                                    ROUTINGDATA.LAND +
                                      ROUTINGDATA.MAIN +
                                      ROUTINGDATA.POSTEDJOB,
                                    {
                                      state: userDetails.userId,
                                    }
                                  );
                                }}
                              >
                                Posted Jobs
                              </ListItemButton>
                            </List>
                          </Collapse>
                        </Grid>
                        {/* <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          <Typography
                            sx={{ fontWeight: 600 }}
                            id="quickactive1"
                            onClick={() => {
                              navigate(
                                ROUTINGDATA.LAND +
                                  ROUTINGDATA.MAIN +
                                  ROUTINGDATA.APPLIEDSEEKERS,
                                {
                                  state: userDetails.userId,
                                }
                              );
                            }}
                          >
                            Applied Seekers
                          </Typography>
                        </Grid> */}
                        <Grid sx={{ pb: 2, cursor: "pointer" }}>
                          <Typography
                            sx={{ fontWeight: 600 }}
                            id="quickactive1"
                            onClick={() => {
                              navigate(
                                ROUTINGDATA.LAND +
                                  ROUTINGDATA.MAIN +
                                  ROUTINGDATA.SUBSCRIPTIONS,
                                {
                                  state: userDetails.userId,
                                }
                              );
                            }}
                          >
                            Buy Posting
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>

                  <Grid
                    id="EmpUpdscroll"
                    sx={{
                      mt: 2,
                    }}
                    container
                    xs={12}
                    sm={12}
                    md={9.4}
                    lg={10}
                  >
                    <Grid
                      ref={CompanyDetailsRoute}
                      className="Card"
                      sx={{ p: 4, mt: 2 }}
                      xs={12}
                      md={12}
                      lg={12}
                    >
                      <CompanyDetails setput={setput} />
                    </Grid>

                    <Grid
                      ref={GovermentProofRoute}
                      className="Card"
                      sx={{ p: 4, mt: 2 }}
                      xs={12}
                      md={12}
                      lg={12}
                    >
                      <CompanyProof setput={setput} />
                    </Grid>

                    <Grid
                      ref={ContactDetailsRoute}
                      className="Card"
                      sx={{ p: 4, mt: 2 }}
                      xs={12}
                      md={12}
                      lg={12}
                    >
                      <ContactPersonDetails setput={setput} />
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </ThemeProvider>
          </div>
        </Context.Provider>
      </>
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        {" "}
        <Dialog TransitionComponent={Transition} open={declined}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            Declined alert !
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {
                "Your profile is declined by admin so please contact contact@jozuna.com."
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setDeclined(false);
                localStorage.removeItem("user");
                navigate(`${ROUTINGDATA.LAND}`);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <div class="dots"></div>
      </div>
    );
  }
};

export default EmployerUpdate;
